import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import App from '../../components/App';
import {
  setUpApp,
  cognitoLoginRefreshToken,
  pickApplication,
  setLastActiveDate,
} from './actions';

const mapStateToProps = state => ({
  applicantStarted: state.application.currentApplicant
    ? state.application.currentApplicant.started
    : false,
  location: state.router.location, // NEVER REMOVE THIS
  authenticated: state.app.authenticated,
  configured: state.app.configured,
  ready: state.application.ready,
  LBStatus: state.status.LBControl,
  signStatus: state.status.sign,
  showApplicationPicker: state.app.showApplicationPicker,
  pickableApplications: state.app.pickableApplications,
  shouldShowNotificationBar: state.notificationBar.shouldShow,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setUpApp,
      cognitoLoginRefreshToken,
      pickApplication,
      setLastActiveDate,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/features/App/index.js